module.exports = __webpack_public_path__ + "img/1st.2c35e3b8.png";